import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormInput from '../../../../library/form/components/FormInput';
import FormRichText from '../../../../library/form/components/FormRichText';
import FormLabel from '../../../../library/form/components/FormLabel';
import FormDialog from "../../../../library/form/components/FormDialog";
import FormTitle from "../../../../library/form/components/FormTitle";
import FormROValue from "../../../../library/form/components/FormROValue1";
import FormSH from "../../../../library/form/components/FormSH";
import { UiGridColTwo, UiCol, UiRow } from "../../../../library/layout/Index";

const BookingShorthand = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam: { "showModeID": "sh" } }} contentStyle={{ height: '450px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Add Booking" />}
        >
            <div className="uiShortHand">
                <UiGridColTwo>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "customer" }} value="Customer" />
                                </span>
                                <FormInput formObject={formObject} rowKey=""
                                    action={{ InputType: "ac", paramName: "customer", acMethod: "%dataList.acMethod", actionId: "refresh", acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 } }}
                                />
                                <FormSH formObject={formObject} rowKey="" action={{
                                    actionId: "new", paramName: "customer",
                                    actionName: "proComp", actionParam: {}, containerKey: "popup"
                                }} >
                                </FormSH>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "companyName" }} value="Billing " />
                                </span>
                                <FormInput formObject={formObject} rowKey=""
                                    action={{ InputType: "ac", paramName: "companyName", acMethod: "%dataList.acMethod", actionId: "refresh", acDepCtrl: { dparam: '%dataList.valLDT', reqPerm: 1 } }}
                                />
                                <FormSH formObject={formObject} rowKey="" action={{
                                    actionId: "new", paramName: "companyName",
                                    actionName: "proComp", actionParam: {}, containerKey: "popup"
                                }} >
                                </FormSH>
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tripMedium" }} value="Trip Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="4"
                                    action={{ InputType: "ac", paramName: "tripMedium", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "tripType" }} value="Travel Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="4"
                                    action={{ InputType: "ac", paramName: "tripType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "ticketType" }} value="Ticket Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="4"
                                    action={{ InputType: "ac", paramName: "ticketType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "classType" }} value="Class Type" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="5"
                                    action={{ InputType: "ac", paramName: "classType", acMethod: "CategoryDetail", acDepCtrl: { 'dparam': "%dataList.valLCat" } }}
                                />
                            </li>
                            
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "origin" }} value="Origin" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="6"
                                    action={{ InputType: "ac", paramName: "origin", acMethod: "Station", acDepCtrl: { dparam: '%dataList.valLDT' } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "destination" }} value="Destination" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" tabindex="7"
                                    action={{ InputType: "ac", paramName: "destination", acMethod: "Station", acDepCtrl: { dparam: '%dataList.valLDT' } }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "deptDate" }} value="Departure Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="8"
                                    action={{ InputType: "dp", paramName: "deptDate" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "returnDate" }} value="Return Date" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="9"
                                    action={{ InputType: "dp", paramName: "returnDate" }}
                                />
                            </li>
                        </ul>
                    </UiCol>
                    <UiCol>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "contact" }} value="Contact" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="2" action={{ InputType: "input", paramName: "contact" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "email" }} value="Email" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="3" action={{ InputType: "input", paramName: "email" }} />
                            </li>
                            
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "seniorPax" }} value="Senior Passengers" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="10"
                                    action={{ InputType: "input", paramName: "seniorPax", actionId: "refresh" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "adultPax" }} value="Adult Passengers" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="11"
                                    action={{ InputType: "input", paramName: "adultPax", actionId: "refresh" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "childrenPax" }} value="Children Passengers" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="12"
                                    action={{ InputType: "input", paramName: "childrenPax", actionId: "refresh" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "infantPax" }} value="Infant Passengers" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="uiInput" tabindex="13"
                                    action={{ InputType: "input", paramName: "infantPax", actionId: "refresh" }}
                                />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "totalPax" }} value="Total Passengers" />
                                </span>
                                <FormROValue format="#" formObject={formObject} rowKey="" action={{ paramName: "totalPax" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExDate" }} value="Ref. Date (Ex)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="" id="refExDatetxt" tabindex="14"
                                    action={{ InputType: "dp", paramName: "refExDate" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refExNo" }} value="Ref. No (Ex)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="refExNotxt" className="uiInput"
                                    action={{ InputType: "input", paramName: "refExNo" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInDate" }} value="Ref. Date (In)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" className="" id="refInDatetxt" tabindex="15"
                                    action={{ InputType: "dp", paramName: "refInDate" }} />
                            </li>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "refInNo" }} value="Ref. No (In)" />
                                </span>
                                <FormInput formObject={formObject} rowKey="" id="refInNotxt" className="uiInput"
                                    action={{ InputType: "input", paramName: "refInNo" }} />
                            </li>
                        </ul>
                    </UiCol>
                    <UiRow>
                        <ul>
                            <li>
                                <span className="uiLbl">
                                    <FormLabel formObject={formObject} rowKey="" action={{ paramName: "spclInstructions" }} value="Special Instructions" />
                                </span>
                                <FormRichText formObject={formObject} rowKey="" rows="5" cols="82" className="uiFrmText"
                                    action={{ paramName: "spclInstructions" }}
                                />
                            </li>
                        </ul>
                    </UiRow>

                </UiGridColTwo>
            </div>
        </FormDialog>
    )
}

export default withView(BookingShorthand, "bookingComp", "bookingComp")